import moment from 'moment';

export const DateToDayName = (date: Date | string) => moment(date).format('ddd');
